<style>
.edi-emailbind {
	height: 100%;
	background-color: #eee;
}
.ui-content .ui-listview-inset {
	margin: 1em 0;
	-webkit-border-radius: .3125em;
	border-radius: .3125em;
}
.ui-btn {
	cursor: pointer;
	padding: .3em .8em;
	margin-right: .3em;
}
</style>

<template>
	<div class="edi-emailbind">
		<navbar title="绑定邮箱"></navbar>
		<div class="ui-content">
			<ul class="ui-listview ui-listview-inset">
				<li class="ui-listview-first-item"><input type="text" placeholder="请输入邮箱地址" v-model="email"/></li>
				<li class="ui-listview-first-item" style="display: flex;border-bottom: 1px solid #ddd">
					<input type="text" name="verifyCode" v-model="verifyCode" placeholder="图形验证码" />
					<img :src="verifyCodeImg" @click="refreshVerifyCodeClick" style="height: 36px" />
				</li>
				<li class="ui-listview-last-item">
					<div class="ui-col-6"><input type="text" placeholder="验证码" v-model="code"/></div
						><div class="ui-col-4 ui-align-right"><email-code :type="4" :email="email" :uuid="verifyUUID" :verifyCode="verifyCode"></email-code></div>
				</li>
			</ul>
			<fieldset class="ui-controlgroup">
				<input type="submit" value="绑定" class="submit" :class="{ 'ui-disable': submitDisable }" @click="bind"/>
			</fieldset>
		</div>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>

<script>
import EmailCode from '../components/EmailCode'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			patrn: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
			codePatrn: /^\d{4}$/,
			code: '',
			email: '',
			sec: 1500,
			goodsTotalInfo: {},
			store: GlobalStore,
			verifyUUID: this.$fxUtils.createUUID(),
			verifyCode: ''
		}
	},
	computed: {
		submitDisable () {
			return !this.code
		},
		verifyCodeImg () {
			return `/cldEdi/business/${this.verifyUUID}/getVerifyCode`
		}
	},
	components: {
		'email-code': EmailCode,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	created () {
		this.goodsTotalInfo = this.store.goodsTotalInfo
		// window.console.log(this.goodsTotalInfo)
	},
	methods: {
		refreshVerifyCodeClick () {
			this.verifyUUID = this.$fxUtils.createUUID()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		tipAutoStatus (msg) {
			this.tipsauto = msg
			window.console.log(msg)
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		delaySkip (path) {
			var self = this
			setTimeout(() => {
				this.$router.push({path: path})
			}, self.sec)
		},
		bind () {
			var bool = this.goodsTotalInfo.emailLinksChange
			if (this.email === '') {
				this.autoTips('邮箱地址不能为空')
				return false
			} else if (!(this.patrn.test(this.email))) {
				this.autoTips('邮箱地址格式不正确')
				return false
			}
			if (this.code === '') {
				this.autoTips('验证码不能为空')
				return false
			} else if (!(this.codePatrn.test(this.code))) {
				this.autoTips('验证码为四位数字')
				return false
			}
			if (this.verifyCode === '') {
				this.autoTips('图形验证码不能为空')
				return false
			}
			this.$http.post('/cldEdi/business/bindingUserMail', {vCode: this.code, email: this.email}).then((response) => {
				if (response.body.result) {
					this.autoTips('邮箱绑定成功')
					if (bool) {
						this.goodsTotalInfo.emailLinksChange = undefined
						var self = this
						setTimeout(() => {
							this.$router.go(-1)
						}, self.sec)
					} else {
						this.delaySkip('/accounts')
					}
				} else {
					this.autoTips(response.body.message)
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// EmailBind.vue?a2cabe1a